import type { UserCreateResponseType } from "@sellar-io/api-v2/types";

export const getUserAccountTypes = ({
  BusinessUsers,
}: Pick<UserCreateResponseType, "BusinessUsers">) => {
  const retailer = BusinessUsers.some(
    ({ Business }) => Business.type === "retailer",
  );
  const supplier = BusinessUsers.some(
    ({ Business }) => Business.type === "supplier",
  );
  return { retailer, supplier, dual: retailer && supplier };
};
